import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LandingRouteService } from 'src/app/services/auth/landing-route.service';

/**
 * Alamat akar ('/') mengarah ke halaman awal sesuai akun: kasir-saja ke /cashier,
 * lainnya ke /dashboard. Belum login: ke halaman login.
 */
@Injectable({ providedIn: 'root' })
export class HomeRedirectGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private landing: LandingRouteService,
    private router: Router
  ) {}

  canActivate(): UrlTree {
    if (!this.auth.isAuthenticated()) {
      return this.router.createUrlTree(['/login']);
    }

    return this.router.parseUrl(this.landing.homeRoute());
  }
}
